import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatTooltipModule } from '@angular/material/tooltip';

interface ICellTooltipParams extends ICellRendererParams {
  classes?: string;
}

@Component({
    selector: 'app-cell-tooltip',
    templateUrl: './cell-tooltip.component.html',
    imports: [CommonModule, TranslateModule, MatTooltipModule]
})
export class CellTooltipComponent implements ICellRendererAngularComp {
  // Fields
  public text = '';
  public toolTipText: string | null = null;

  @ViewChild('cellElement', { static: false }) private cellElementRef!: ElementRef;

  // Ag Grid Lifecycle Hooks
  public agInit(params: ICellTooltipParams): void {
    this.text = this.extractValue(params);
  }

  public refresh(params: ICellTooltipParams): boolean {
    this.text = this.extractValue(params);
    return true;
  }

  // Host Listener
  @HostListener('mouseenter') public onMouseEnter(): void {
    this.toolTipText = this.getTooltipTextOnOverflow();
  }

  // Private Methods
  private extractValue(params: ICellTooltipParams): string {
    return params.valueFormatted ?? params.value ?? '';
  }

  private getTooltipTextOnOverflow(): string | null {
    if (
      this.cellElementRef &&
      this.cellElementRef.nativeElement.scrollWidth > this.cellElementRef.nativeElement.offsetWidth
    ) {
      return this.text;
    }
    return null;
  }
}
